import type { ReviewEntryItem } from '../types/reviewEntryItem'

export const getReviewEntryId = (entry: ReviewEntryItem, entryIndex: number): string =>
  entry.documentId ?? entry.id ?? `entry-${entryIndex}`
